export function desc (a, b, orderBy) {
  if (b[orderBy].toString().toLowerCase() < a[orderBy].toString().toLowerCase()) {
    return -1
  }
  if (b[orderBy].toString().toLowerCase() > a[orderBy].toString().toLowerCase()) {
    return 1
  }
  return 0
}

export function stableSort (array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

export function getSorting (order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy)
}

// Use by calling stableSort(array, getSorting(order, fieldName))
// where order = 'asc' or 'desc'



// WEBPACK FOOTER //
// ./src/app/utilities/sortByField.js